/**
 * logger.js – Debug logging & performance timing utilities.
 *
 * Usage:
 *   import { debugLog, startPerformanceTimer } from './logger';
 *
 * Enable verbose logs at runtime:
 *   window.TWINWORLD_DEBUG = true   (in browser console)
 */

/**
 * Debug logging helper.
 * @param {string} category - e.g. 'handleSubmit', 'API Request'
 * @param {string} message
 * @param {*}      [data]   - optional payload (logged as an object)
 */
export const debugLog = (category, message, data) => {
    if (window.TWINWORLD_DEBUG) {
        const timestamp = new Date().toISOString();
        const prefix = `[Scenes.js][${category}]`;
        if (data !== undefined) {
            console.log(`${prefix} ${message}`, { timestamp, data });
        } else {
            console.log(`${prefix} ${message}`, { timestamp });
        }
    }
};

/**
 * Start a performance timer.
 * @param {string} operationName
 * @returns {() => string} Call the returned function when the operation ends
 *                         to log the duration and get it back as a string.
 */
export const startPerformanceTimer = (operationName) => {
    const startTime = performance.now();
    return () => {
        const duration = (performance.now() - startTime).toFixed(2);
        debugLog('Performance', `${operationName} completed`, { duration: `${duration}ms` });
        return duration;
    };
};
